import { FC } from 'react';
import CustomDataTable from 'pages/private/FeedbackEvaluation/tables/CustomDataTable2';
import { Cell } from 'react-table';
import { useListRoutineLunchQuestionQuery } from 'redux/reducers/routineFeedback';
import { useParams } from 'react-router-dom';

interface IRoutineManagementTable {
  tableHeaders?: () => React.ReactNode;
}

const LunchFeedbackTable: FC<IRoutineManagementTable> = ({ tableHeaders }) => {
  const { id } = useParams();

  const { data: lunchQuestionData, isLoading } = useListRoutineLunchQuestionQuery(id);
  console.log('lunchQuestionData::',lunchQuestionData);
  

  const columns = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (cell: Cell) => {
        return cell.row.index + 1;
      }
    },
    {
      Header: 'Feedback in English',
      accessor: 'question'
    },
    {
      Header: 'Feedback in Nepali',
      accessor: 'question_np'
    }
  ];

  return (
    <>
      <CustomDataTable
        tableHeaders={tableHeaders}
        columns={columns}
        data={
          (!!lunchQuestionData?.data?.length &&
            lunchQuestionData?.data?.[0]?.feedback_question_details) ||
          []
        }
      />
    </>
  );
};

export default LunchFeedbackTable;
